module.exports = "<ion-app style=\"-webkit-overflow-scroll: auto;\">\r\n  <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n"